import React, { useState } from "react";

const Kontakt = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        spamcontrol: "",
        message: "",
    });
    const [isSubmitting, setIsSubmitting] = useState(false); // Stav pro deaktivaci tlačítka

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Kontrola spamu - musí být číslo 5
        if (formData.spamcontrol !== "5") {
            alert("Kontrola spamu má špatnou hodnotu. Zkuste to znovu.");
            return;
        }

        setIsSubmitting(true); // Deaktivace tlačítka během odesílání

        try {
            const response = await fetch("https://rychlydum.cz/phpmailer/form-handler.php", {
                method: "POST",
                body: JSON.stringify(formData),
                headers: {
                    "Content-Type": "application/json",
                },
            });

            const result = await response.json();

            if (result.status === "success") {
                alert("Formulář byl úspěšně odeslán.");
                setFormData({
                    name: "",
                    email: "",
                    phone: "",
                    spamcontrol: "",
                    message: "",
                }); // Vyčištění formuláře
            } else {
                alert("Chyba při odesílání formuláře. Zkuste to znovu.");
            }
        } catch (error) {
            alert("Chyba při spojení se serverem.");
        }

        setIsSubmitting(false); // Opětovné povolení tlačítka
    };

    return (
        <div id="content" className="kontakt">
            <div className="container">
                <h1>Kontakty</h1>
                <div className="boxes">
                    <div className="item">
                        <h4>Kontaktní linka</h4>
                        <p>
                            <strong>telefon: <a href="tel:+420607867936">+420 607 867 936</a></strong><br />
                            <strong>e-mail: <a href="mailto:info@rychlydum.cz">info@rychlydum.cz</a></strong>
                        </p>
                        <p>
                            k dispozici pro vaše dotazy<br />
                            v pracovní dny 8:00 - 17:30
                        </p>
                    </div>
                    <div className="item">
                        <h4>Výrobní hala</h4>
                        <p>
                            Jiráskova 77<br />
                            277 06<br />
                            Lužec nad Vltavou
                        </p>
                        <a href="https://mapy.com/cs/turisticka?source=addr&id=9695364&ds=1&x=14.4036500&y=50.3199330&z=17" className="bttn" target="_blank">Zobrazit mapu</a>
                    </div>
                    <div className="item">
                        <h4>Vzorový dům</h4>
                        <p>
                            Pašinka 271<br />
                            280 02 Pašinka<br />
                            okres Kolín
                        </p>
                        <a href="https://mapy.com/cs/zakladni?source=muni&id=3457&ds=1&x=15.1799358&y=49.9954246&z=14" className="bttn" target="_blank">Zobrazit mapu</a>
                    </div>
                </div>
            </div>
            <div className="light-grey-bg">
                <div className="container">
                    <div className="form-wrapper">
                        <h3>Napište nám zprávu</h3>
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label>Jméno<span className="required">*</span></label>
                                <input type="text" name="name" value={formData.name} onChange={handleChange} required className="form-control" />
                            </div>
                            <div className="form-group">
                                <label>E-mail<span className="required">*</span></label>
                                <input type="email" name="email" value={formData.email} onChange={handleChange} required className="form-control" />
                            </div>
                            <div className="form-group">
                                <label>Telefon<span className="required">*</span></label>
                                <input type="number" name="phone" value={formData.phone} onChange={handleChange} required className="form-control" />
                            </div>
                            <div className="form-group spam">
                                <label>Kontrola spamu<span className="required">*</span> 3+2=</label>
                                <input type="text" name="spamcontrol" value={formData.spamcontrol} onChange={handleChange} required className="form-control" />
                            </div>
                            <div className="form-group w-100">
                                <textarea name="message" placeholder="Zde napište svoji zprávu..." value={formData.message} onChange={handleChange} required className="form-control" />
                            </div>
                            <p>
                                Odesláním formuláře souhlasíte se zpracováním zadaných údajů pro případné kontaktování naším pracovníkem.<br />
                                Zadané údaje budou uchovány správcem pouze po nezbytně nutnou dobu a nebudou bez souhlasu dále předávány.
                            </p>
                            <button type="submit" className="bttn" disabled={isSubmitting}>
                                {isSubmitting ? "Odesílání" : "Odeslat"}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="bottom-text">
                    <h4>Provozovatel webu</h4>
                    <p><strong>erste marketing s.r.o.</strong>, Sokolská 1095, 28002 Kolín, IČ: 23664733, společnost zapsaná u Městského soudu v Praze, oddíl C složka 2332</p>
                </div>
            </div>
        </div>
    );
};

export default Kontakt;
